import { publicClient, privateClient } from './client';
import { ItemInventory } from './ItemInventory';

const inventoryPbcItemInventory = (pub: boolean) => new ItemInventory(pub ? publicClient : privateClient);
export default inventoryPbcItemInventory;
